import React from 'react';
import ModalComponent from '../../../molecules/Modal';

/**
 * Render login form in a popup modal Component
 * @param {*} props - Object
 */
export const SearchStoreInsideModal = props => {
  const { handleClose, handleGoBack, orderModeTypeItem, headerText, modalTitleId = '' } = props;
  return (
    <React.Fragment>
      <ModalComponent
        data-testid='searchStoreCardModal'
        id='searchStoreCard'
        role='dialog'
        modalTitleId={modalTitleId}
        show={true}
        classNames='search-store-modal extra-small-modal'
        showCloseBtn={true}
        showBackBtn={true}
        closeButtonHandler={handleClose}
        backButtonHandler={handleGoBack}
        modalTitle={headerText}
        autoFocus={true}
      >
        {orderModeTypeItem}
      </ModalComponent>
    </React.Fragment>
  );
};

export default SearchStoreInsideModal;
